import { NgModule } from '@angular/core';
import { NZ_ICONS, NzIconModule } from 'ng-zorro-antd/icon';

import {
  MenuFoldOutline,
  MenuUnfoldOutline,
  FormOutline,
  DashboardOutline,
  SaveOutline,
  CheckOutline,
  DeleteOutline,
  PrinterOutline,
  SyncOutline,
  RobotOutline,
  CloseOutline,
  SendOutline,
  WarningOutline,
  TableOutline,
  ClockCircleOutline,
  PieChartOutline,
  LockOutline,
  ReloadOutline,
  FullscreenOutline,
  FullscreenExitOutline,
  PlusOutline,
} from '@ant-design/icons-angular/icons';

const icons = [
  MenuFoldOutline,
  MenuUnfoldOutline,
  DashboardOutline,
  FormOutline,
  SaveOutline,
  CheckOutline,
  DeleteOutline,
  PrinterOutline,
  SyncOutline,
  RobotOutline,
  CloseOutline,
  SendOutline,
  WarningOutline,
  TableOutline,
  ClockCircleOutline,
  PieChartOutline,
  LockOutline,
  ReloadOutline,
  FullscreenOutline,
  FullscreenExitOutline,
  PlusOutline,
];

@NgModule({
  imports: [NzIconModule],
  exports: [NzIconModule],
  providers: [{ provide: NZ_ICONS, useValue: icons }],
})
export class IconsProviderModule { }
